module.exports = {
      id: "video-usage",
      viewBox: "0 0 84 64",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#video",
      toString: function () {
        return this.url;
      }
    }